<form [formGroup]="operationsForm">
    <div class="row">

        <!-- Name -->
        <div class="col-12 col-md-6 mb-4">
            <app-input-field
                name="name"
                identifier="name"
                formControlName="name"
                [label]="TRANSLATE_KEY_MAP.FORM.NAME.LABEL() | translate"
                [placeholder]="TRANSLATE_KEY_MAP.FORM.NAME.PLACEHOLDER() | translate"
            />
        </div>

        <!-- Level -->
        <div class="col-12 col-md-6 mb-4">
            <app-input-field
                type="number"
                [valueAsNumber]="true"
                name="default_level"
                identifier="default_level"
                formControlName="default_level"
                [label]="TRANSLATE_KEY_MAP.FORM.LEVEL.LABEL() | translate"
                [placeholder]="TRANSLATE_KEY_MAP.FORM.LEVEL.PLACEHOLDER() | translate"
            />
        </div>

        <!-- Description -->
        <div class="col-12 mb-4">
            <app-textarea
                name="description"
                identifier="description"
                formControlName="description"
                [label]="TRANSLATE_KEY_MAP.FORM.DESCRIPTION.LABEL() | translate"
                [placeholder]="TRANSLATE_KEY_MAP.FORM.DESCRIPTION.PLACEHOLDER() | translate"
            />
        </div>

        <!-- Icon -->
        <!-- <div class="col-12 mb-4">
            <label for="icon_id" class="form-label">{{ TRANSLATE_KEY_MAP.FORM.ICON.LABEL() | translate }}</label>
            <ng-select
                id="icon_id"
                [items]="[]"
                name="icon_id"
                bindValue="id"
                bindLabel="name"
                formControlName="icon_id"
                [placeholder]="TRANSLATE_KEY_MAP.FORM.ICON.PLACEHOLDER() | translate"
            />
        </div> -->

        <!-- Default type for its level -->
        <div class="col-12">
            <app-switch
                name="default_type_for_its_level"
                identifier="default_type_for_its_level"
                formControlName="default_type_for_its_level"
                [label]="TRANSLATE_KEY_MAP.FORM.DEFAULT_TYPE_FOR_ITS_LEVEL.LABEL() | translate"
            />
        </div>

    </div>
</form>